<template>
  <div class="dashboard-main" v-if="user && !loading">
    <div class="margin-x margin-y">
      <v-row>
        <v-col cols="12">
          موجودی حساب : {{ user.wallet.value }} تومان
        </v-col>
        <v-col cols="12">
          <v-btn style="letter-spacing: normal" block class="white--text" color="#1ab69d" @click="openDepositWallet()">
            افزایش
            موجودی
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-1 my-4">
          <v-row class="card-dashboard" style="background-color: #3dc3a2" @click="$router.push('/dashboard/profile')">
            <v-col cols="12" class="text-center">
              <v-icon color="white" large>mdi-account</v-icon>
            </v-col>
            <v-col cols="12" class="text-center text-menu">پروفایل</v-col>
          </v-row>
        </v-col>
        <v-col class="mx-1 my-4">
          <v-row class="card-dashboard" style="background-color: #f7be45"
                 @click="$router.push('/dashboard/my-courses')">
            <v-col cols="12" class="text-center">
              <v-icon color="white" large>mdi-bookshelf</v-icon>
            </v-col>
            <v-col cols="12" class="text-center text-menu">درس ها</v-col>
          </v-row>
        </v-col>
        <v-col class="mx-1 my-4">
          <v-row class="card-dashboard" style="background-color: #de4756" @click="$router.push('/dashboard/courses')">
            <v-col cols="12" class="text-center">
              <v-icon color="white" large>mdi-folder-multiple-outline</v-icon>
            </v-col>
            <v-col cols="12" class="text-center text-menu">فروشگاه</v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-1 my-4">
          <v-row class="card-dashboard" style="background-color: #93c75a"
                 @click="$router.push('/dashboard/about/courses-instructors')">
            <v-col cols="12" class="text-center">
              <v-icon color="white" large>mdi-book-open-variant</v-icon>
            </v-col>
            <v-col cols="12" class="text-center text-menu">درباره دوره</v-col>
          </v-row>
        </v-col>
        <v-col class="mx-1 my-4">
          <v-row class="card-dashboard" style="background-color: #91c1c0"
                 @click="$router.push('/dashboard/transactions')">
            <v-col cols="12" class="text-center">
              <v-icon color="white" large>mdi-currency-usd</v-icon>
            </v-col>
            <v-col cols="12" class="text-center text-menu">تراکنش ها</v-col>
          </v-row>
        </v-col>
        <v-col class="mx-1 my-4">
          <v-row class="card-dashboard" style="background-color: #4c8bde"
                 @click="$router.push('/dashboard/online-sessions')">
            <v-col cols="12" class="text-center">
              <v-icon color="white" large>mdi-monitor</v-icon>
            </v-col>
            <v-col cols="12" class="text-center text-menu">جلسات آنلاین</v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-1 my-4">
          <v-row class="card-dashboard" style="background-color: #6B35C8"
                 @click="$router.push('/dashboard/assessments')">
            <v-col cols="12" class="text-center">
              <v-icon color="white" large>mdi-clipboard-check-outline</v-icon>
            </v-col>
            <v-col cols="12" class="text-center text-menu">ارزیابی</v-col>
          </v-row>
        </v-col>
        <v-col class="mx-1 my-4">
          <v-row class="card-dashboard" style="background-color: #d98c01">
            <v-col cols="12" class="text-center">
              <v-icon color="white" large>mdi-face-agent</v-icon>
            </v-col>
            <v-col cols="12" class="text-center text-menu">پشتیبانی</v-col>
          </v-row>
        </v-col>
        <v-col class="mx-1 my-4">
          <v-row class="card-dashboard" style="background-color: #cd7aea"
                 @click="$router.push('/dashboard/notifications')">
            <v-col cols="12" class="text-center">
              <v-badge :content="notifications.length" color="error">
                <v-icon color="white" large>mdi-bell-badge-outline</v-icon>
              </v-badge>
            </v-col>
            <v-col cols="12" class="text-center text-menu">اعلان ها</v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-1 my-4">
          <v-row class="card-dashboard" style="background-color: #68e105" @click="$router.push('/')">
            <v-col cols="12" class="text-center">
              <v-icon color="white" large>mdi-remote-desktop</v-icon>
            </v-col>
            <v-col cols="12" class="text-center text-menu">صفحه اصلی</v-col>
          </v-row>
        </v-col>
        <v-col>
        </v-col>
        <v-col>
        </v-col>
      </v-row>
      <div class="main-notification" v-if="subscriptions.length">
        <h4 class="mb-2"> اشتراک فعال شما</h4>
        <div v-for="subscription in subscriptions" :key="subscription.id">
          <strong> {{ subscription.title }} </strong>
          <br>
          <p v-html="subscription.subtitle">
          </p>
          <div>
            فعال تا :
            {{ expire }}
          </div>
        </div>
      </div>
      <div class="has-not-subscription mx-8" v-else>
        <h3 class="mb-2">شما هیچ اشتراک فعالی ندارید.</h3>
        <v-row>
          <v-col class="text-center normal-button">
            <v-btn @click="$router.push('/dashboard/subscriptions')">
              خرید اشتراک
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-dialog v-model="depositDialog" width="100%">
      <v-card>
        <v-card-actions>
          <v-icon color="error" @click="depositDialog = false">mdi-close</v-icon>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field color="black" hint="به تومان وارد شود." v-model="amount"
                            label="مقدار افزایش موجودی را وارد کنید"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field color="black" label="توضیحات" v-model="description"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-btn block color="#1ab69d" @click="deposit()" style="letter-spacing: normal" class="white--text">انتقال
                به
                درگاه پرداخت
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Echo from "laravel-echo";

export default {
  name: "DashboardMobile",
  data() {
    return {
      notifications: [],
      hasValidSubscription: true,
      expire: null,
      subscriptions: [],
      amount: null,
      description: null,
      depositDialog: false,
      user: null,
      loading: true
    }
  },
  mounted() {
    this.user = this.$store.state.user
    this.getActiveSubscriptions()
    this.getNotifications()
    this.initialWS()
    this.initialListenWs()
  },
  methods: {
    openDepositWallet() {
      this.depositDialog = true
    },
    deposit() {
      window.axios.post('/finance/wallet/charge', {
        amount: this.amount,
        description: this.description
      }).then((res) => {
        let url = JSON.parse(res.data.data)
        console.log(url.action)
        window.location.href = url.action
      })
    },
    getActiveSubscriptions() {
      window.axios.get('student/subscriptions/my', this.course).then((res) => {
        this.subscriptions = res.data.data.subscriptions
        this.expire = res.data.data.expire?.expire_fa
        this.loading = false
      }).catch((err) => {
        this.loading = false
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    initialWS() {
      if (!this.$store.state.user) {
        return
      }
      this.$store.state.Echo = new Echo({
        broadcaster: 'pusher',
        key: 'myKey',
        cluster: 'mt1',
        wsHost: process.env.VUE_APP_WS_HOST,
        wsPort: process.env.VUE_APP_WS_PORT,
        forceTLS: process.env.VUE_APP_FORCE_TLS !== 'false',
        disableStats: true,
        encrypted: true,
        auth: {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        },
        authorizer: (channel) => {
          return {
            authorize: (socketId, callback) => {
              window.mainAxios.post('/api/students/broadcasting/auth', {
                socket_id: socketId,
                channel_name: channel.name
              }, {
                headers: {
                  Authorization: this.$cookies.get('token')
                }
              })
                  .then(response => {
                    callback(false, response.data);
                  })
                  .catch(error => {
                    callback(true, error);
                  });
            }
          };
        },
      });
      this.$store.state.loadingEcho = false
    },
    listenWs(type) {
      if (type === 'immediately') {
        this.$store.state.Echo.private('send.notification.' + this.$store.state.user.id)
            .listen('SendNotification', () => {
              this.getNotifications()
            })
      } else {
        let self = this
        window.setTimeout(function () {
          self.$store.state.Echo.private('send.notification.' + self.$store.state.user.id)
              .listen('SendNotification', () => {
                self.getNotifications()
              })
        }, 3000)
      }
    },
    initialListenWs() {
      if (!this.$store.state.user) {
        return
      }
      if (!this.$store.state.loadingEcho) {
        this.listenWs('immediately')
      } else {
        this.listenWs('wait')
      }
    },
    getNotifications() {
      window.axios.get('student/notification/index/unseen').then((res) => {
        this.notifications = res.data.data
      })
    }
  }
}
</script>

<style scoped>
.dashboard-main {
  overflow-x: hidden !important;
  background: #1ab69d;
  background: radial-gradient(circle, #36f3d7 1%, #feffff 100%);
  height: 100vh;
}

.margin-x {
  margin-left: 10vw;
  margin-right: 10vw;
}

.card-dashboard {
  border-radius: 15px;
}

.margin-y {
  margin-top: 5vh;
}

.text-menu {
  font-size: 15px;
  color: white;
}


.main-notification {
  padding: 10px !important;
  height: 200px;
  width: 80% !important;
  background-color: rgba(230, 230, 230, 0.65) !important;
  display: table !important;
  margin: auto !important;
  border-radius: 20px !important;
}

.normal-button {
  letter-spacing: normal !important;
}

.has-not-subscription {
  padding: 10px !important;
  height: 200px;
  width: 80% !important;
  background-color: rgba(255, 170, 170, 0.65) !important;
  display: table !important;
  border-radius: 20px !important;
  margin-bottom: 20vh !important;
}
</style>
